import Contact13 from './Contact13'
export default Contact13
